

export default () => {
  const closeToggle = document.getElementById('global-nav-close-toggle'),
        nav = document.getElementById('global-nav'),
        toggle = document.getElementById('global-nav-toggle');

  toggle.addEventListener('click', () => {
    if(!nav.classList.contains('active')) {
      nav.classList.add('active');
    }
  });

  closeToggle.addEventListener('click', () => {
    if(nav.classList.contains('active')) {
      nav.classList.remove('active');
    }
  });
}


// WEBPACK FOOTER //
// ./src/scripts/menu.js